module.exports = __webpack_public_path__ + "img/Mr_Monkey.aa524c7c.jpeg";